const SET_IS_CLASS_STUDENT = 'classes/SET_IS_CLASS_STUDENT';
const SET_SELECTED = 'classes/SET_SELECTED';
const SET_CLASSES = 'classes/SET_CLASSES';

export default {
  SET_IS_CLASS_STUDENT,
  SET_SELECTED,
  SET_CLASSES,
};



// WEBPACK FOOTER //
// ./src/app/classes/store/mutation-types.js